import * as Yup from 'yup';
import { SpecificTarget, Program } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<SpecificTarget>().shape({
    name: Yup.string().nullable().required(),
    parent: Yup.object<Program>().nullable().required(),
  });
}
